// Source IDs
export const UNIFIED_SOURCE = 'unified-source'
export const CLUSTER_IMG_SOURCE = 'cluster-img-source'
export const GEOFENCE_SOURCE = 'geofence-source'
export const TRAIL_SOURCE = 'trail-source'
// Fuente dedicada sin clustering para el heatmap de incidentes. La unified
// source tiene cluster:true así que a zoom bajo los puntos desaparecen
// (se agrupan) y el heatmap no tiene nada que renderizar — inútil para ver
// densidad desde lejos. Por eso una source separada con solo incidentes
// (últimas 24 h) pre-filtrados en JS.
export const HEATMAP_INCIDENTS_SOURCE = 'heatmap-incidents-source'
// Fuente con el polígono de la frontera del Estado de México (jurisdicción
// del C4). Se usa para pintar un outline del estado como anclaje visual.
export const JURISDICTION_SOURCE = 'jurisdiction-source'
// Fuente con un polígono "inverse" (rectángulo grande con hoyo en EdoMex)
// que sirve de máscara para oscurecer todo lo que NO es EdoMex.
export const JURISDICTION_MASK_SOURCE = 'jurisdiction-mask-source'

// Layer IDs (z-order)
export const LAYERS = {
  GEOFENCE_FILL: 'geofence-fill',
  GEOFENCE_LINE: 'geofence-line',
  UNIFIED_CLUSTERS: 'unified-clusters',
  UNIFIED_CLUSTER_ICONS: 'unified-cluster-icons',
  UNIFIED_STATIC_GLOW: 'unified-static-glow',
  UNIFIED_STATIC_BG: 'unified-static-bg',
  // Placa de color debajo del ícono de cámara que codifica el ámbito
  // (estatal / municipal / otro) — sobresale ~4px alrededor del marker
  // como borde. Imagen SDF recoloreable via icon-color data-driven.
  // También la usan los botones de pánico con color de grupo configurado.
  CAMERA_OWNERSHIP_RING: 'camera-ownership-ring',
  UNIFIED_STATIC_ICONS: 'unified-static-icons',
  // Velo del color del ámbito ENCIMA del ícono de cámara (opacidad muy
  // baja): tiñe el fondo teal hacia el color del dueño sin mezclarse con
  // el basemap. Va después de UNIFIED_STATIC_ICONS en el z-order.
  CAMERA_OWNERSHIP_TINT: 'camera-ownership-tint',
  UNIFIED_DYNAMIC_GLOW: 'unified-dynamic-glow',
  UNIFIED_DYNAMIC_BG: 'unified-dynamic-bg',
  UNIFIED_DYNAMIC_ICONS: 'unified-dynamic-icons',
  // Logo del proveedor externo de interconexión (Carbyne / DiDi / Uber /
  // RapidSOS) sobrepuesto sobre la esquina superior derecha del marker
  // en reportant e incident. Se renderiza por encima de los icon layers
  // y se filtra por `['has', 'partner']` para no afectar markers sin
  // sistema de interconexión adjunto.
  UNIFIED_PARTNER_BADGE: 'unified-partner-badge',
  // Etiquetas de texto separadas en dos capas para poder dar trato distinto
  // a las "criticas" (incident, sos_call, reportant, sensor:alert — labelPriority>=3)
  // que se dibujan sin collision detection y siempre se ven, vs. el resto
  // (labelPriority<3) que respeta el modo (dense/smart/minimal).
  UNIFIED_LABELS_COLLIDE: 'unified-labels-collide',
  UNIFIED_LABELS_PRIORITY: 'unified-labels-priority',
  // Halos del sistema visual de markers (MARKERS-DESIGN-SPEC.md §1.3).
  // Outer: halo exterior más grande y tenue. Se split en 2 layers
  //   (static/pulse) para que la versión pulsante solo tenga que
  //   modularse via setPaintProperty sobre el subset que pulsa.
  // Inner: halo interior más chico e intenso, siempre estático.
  UNIFIED_HALO_OUTER_STATIC: 'unified-halo-outer-static',
  UNIFIED_HALO_OUTER_PULSE: 'unified-halo-outer-pulse',
  UNIFIED_HALO_INNER: 'unified-halo-inner',
  // Overlay tenue del halo outer — renderiza ENCIMA de los iconos para
  // que el halo de un alert se perciba sobre los markers vecinos
  // (cámaras/LPRs/etc que tapaban el halo desde debajo).
  UNIFIED_HALO_OUTER_OVERLAY: 'unified-halo-outer-overlay',
  UNIFIED_HEATMAP: 'unified-heatmap',
  // Punto pequeño que indica el centro real cuando un grupo de incidentes
  // comparte coord exacta y el spread radial está activo. Se filtra por
  // properties.spreadActive=true; sin spread, la layer queda vacía.
  // Visualmente refuerza al operador "aquí está el lat/lon real, los N
  // markers a su alrededor son todos del mismo punto".
  UNIFIED_SPREAD_CENTER: 'unified-spread-center',
  // Trails GPS (MARKERS-DESIGN-SPEC.md §6). Tres pares (line + dots) por
  // tipo de entidad — cada uno con estilo dedicado. El TrailRenderer etiqueta
  // cada feature con properties.entityType para que el filter por layer
  // discrimine el render.
  // Cada rastro lleva su capa de flechas: sin ellas hay que mirar el trazo un
  // rato para deducir hacia dónde iba la unidad, y en un recorrido que
  // zigzaguea eso es leer el mapa dos veces.
  TRAIL_LINE: 'trail-line',                     // device follow (default)
  TRAIL_ARROWS: 'trail-arrows',
  TRAIL_DOTS: 'trail-dots',
  TRAIL_LINE_SOS: 'trail-line-sos',             // sos_call (rojo sólido 3px 85%)
  TRAIL_ARROWS_SOS: 'trail-arrows-sos',
  TRAIL_DOTS_SOS: 'trail-dots-sos',
  TRAIL_LINE_REPORTANT: 'trail-line-reportant', // reportant (amber dashed 2px 55%)
  TRAIL_ARROWS_REPORTANT: 'trail-arrows-reportant',
  TRAIL_DOTS_REPORTANT: 'trail-dots-reportant',
  // Medida cautelar: rastro corto con sentido de marcha (ver addTrailLayers).
  TRAIL_LINE_MC: 'trail-line-mc',
  TRAIL_ARROWS_MC: 'trail-arrows-mc',
  TRAIL_DOTS_MC: 'trail-dots-mc',
  // Outline del Estado de México (jurisdicción operativa del C4).
  // Se pinta DEBAJO de las geocercas para no competir cromáticamente
  // con los colores que definió el backend para cada geocerca.
  JURISDICTION_MASK: 'jurisdiction-mask',           // inverse fill: oscurece fuera del EdoMex
  JURISDICTION_LINE_GLOW: 'jurisdiction-line-glow', // outline blurry (halo)
  JURISDICTION_LINE: 'jurisdiction-line',           // outline sólido (edge sharp)
}

export const INTERACTIVE_LAYERS = [LAYERS.UNIFIED_STATIC_ICONS, LAYERS.UNIFIED_DYNAMIC_ICONS]

// Thresholds
export const DOM_MARKER_MIN_ZOOM = 22 // Effectively disabled — labels handled by symbol layer collision detection

// Tamaño en píxeles del texto de las labels de feature (UNIFIED_LABELS_*).
// Compartido entre layer-manager (text-size) y overlap-spreader (conversión
// px → em para el offset del label cuando el feature está en spread).
// Cambiar este valor afecta ambos lugares — mantener sincronizados.
export const LABEL_TEXT_SIZE_PX = 11
export const SMOOTH_MOVE_FRAMES = 30
export const SMOOTH_MOVE_INTERVAL_MS = 50

// Animation Manager — smooth position interpolation
export const ANIM_DURATION_MS = 3000          // Duración de interpolación (match con intervalo GPS ~3s)
export const ANIM_FLUSH_INTERVAL_MS = 66      // ~15fps — throttle de updateData()
export const ANIM_DEGRADE_INTERVAL_MS = 100   // ~10fps — throttle degradado bajo carga
export const ANIM_DEGRADE_AFTER = 5           // frames lentos consecutivos antes de degradar
export const ANIM_RECOVER_AFTER = 10          // frames rápidos consecutivos antes de recuperar
export const ANIM_SLOW_FRAME_MS = 80          // umbral para considerar un frame "lento"
export const ANIM_FAST_FRAME_MS = 50          // umbral para considerar un frame "rápido" (recuperación)

export const CLUSTER_RADIUS = 60
export const DEFAULT_CLUSTER_MAX_ZOOM = 13
export const MAX_SIDEBAR_ITEMS = 50

// ── Basemap style URLs ──────────────────────────────────────────────
// styleId → mapa de MapTiler (usado como fallback cuando NO hay self-host,
// y siempre para 'satellite' porque las ortofotos no se auto-hospedan).
const MAPTILER_STYLE_IDS = {
  dark: 'dataviz-dark',
  satellite: 'hybrid',
  streets: 'streets-v2-dark',
  light: 'dataviz',
}

// Estilos disponibles self-hosteados (satellite NO — sigue en MapTiler hybrid).
const SELF_HOSTED_STYLE_IDS = ['dark', 'light', 'streets']

// Pura y testeable desde el navegador (no lee env). Decide la URL del style:
//  - satellite: SIEMPRE MapTiler hybrid. REQUIERE apiKey — si se quita
//    VITE_MAPTILER_KEY, satélite (y el fallback) dejan de cargar; por eso la
//    key se conserva aunque haya self-host activo.
//  - dark/light/streets: self-hosted si hay `tilesBaseUrl`; si no, MapTiler.
//  - styleId desconocido: cae a 'dark' (self-host) o dataviz-dark (fallback),
//    igual que el histórico `styles[styleId] || styles.dark`.
// `tilesBaseUrl` vacío/undefined => modo fallback MapTiler (idéntico al anterior).
export function buildStyleUrl(styleId, apiKey, tilesBaseUrl) {
  if (styleId === 'satellite') {
    return `https://api.maptiler.com/maps/${MAPTILER_STYLE_IDS.satellite}/style.json?key=${apiKey}`
  }
  if (tilesBaseUrl) {
    const id = SELF_HOSTED_STYLE_IDS.includes(styleId) ? styleId : 'dark'
    return `${tilesBaseUrl}/styles/${id}.json`
  }
  const maptilerId = MAPTILER_STYLE_IDS[styleId] || MAPTILER_STYLE_IDS.dark
  return `https://api.maptiler.com/maps/${maptilerId}/style.json?key=${apiKey}`
}

// Wrapper que inyecta la env de Vite. Es el punto que consumen maplibre-init
// y MapV2.vue. `VITE_TILES_BASE_URL` vacío => fallback MapTiler.
export function getStyleUrl(styleId, apiKey) {
  return buildStyleUrl(styleId, apiKey, import.meta.env.VITE_TILES_BASE_URL)
}

// Atribución requerida por las fuentes self-hosteadas (OpenMapTiles + OSM +
// Overture Maps). Se muestra en un AttributionControl compacto SOLO si la
// bandera VITE_TILES_ATTRIBUTION === 'true' (ver maplibre-init.js). HTML con
// enlaces, separado por '·'. Para un C5 de gobierno conviene dejarla activa.
export const TILES_ATTRIBUTION_HTML = [
  '<a href="https://openmaptiles.org/" target="_blank" rel="noopener">© OpenMapTiles</a>',
  '<a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">© OpenStreetMap</a>',
  '<a href="https://overturemaps.org/" target="_blank" rel="noopener">© Overture Maps</a>',
].join(' · ')

export const DEFAULT_CENTER = [-99.1332, 19.4326]
export const DEFAULT_ZOOM = 12

// ── Theme color resolver ────────────────────────────────────────────
// Los colores de entidad y estado ahora son dinamicos: leen CSS vars
// del DOM para poder cambiar con el tema activo. La cache se invalida
// al recibir un evento `themechange` (no emitido hoy porque cambiar
// tema hace window.location.reload, pero deja la puerta abierta).

const _cssVarCache = new Map()

export function readCssVar(name) {
  if (_cssVarCache.has(name)) return _cssVarCache.get(name)
  if (typeof document === 'undefined') return ''
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(`--kln-${name}`).trim()
  _cssVarCache.set(name, value)
  return value
}

export function invalidateThemeCache() {
  _cssVarCache.clear()
}

if (typeof window !== 'undefined') {
  window.addEventListener('themechange', invalidateThemeCache)
}

// Entity colors — leen CSS vars del tema activo. Primero intentan leer
// los tokens del sistema declarativo de markers (AJUSTE-PALETA-MARKERS)
// `--kln-marker-<nombre-semantico>` que corresponden al estado "normal"
// de cada capa; si no están emitidos (flag OFF o al init antes de
// applyMarkerPalette), caen al Sistema B legacy.
//
// Usado por: toggles del toolbar, chips del drawer, cluster cards, y
// cualquier componente que quiera pintar en el color de tipo.
function readMarker(nombreSemantico, fallback) {
  return readCssVar('marker-' + nombreSemantico) || readCssVar(fallback)
}

export const ENTITY_COLORS = {
  get device()                { return readMarker('patrulla-normal', 'entity-blue') },
  get bus()                   { return readMarker('bus-normal',      'entity-green') },
  get camera()                { return readMarker('camara-normal',   'entity-teal') },
  get lpr()                   { return readMarker('lpr-normal',      'entity-teal') },
  get sensor()                { return readMarker('sensor-standby',  'entity-red') },
  get external_sensor()       { return readMarker('camara-normal',   'entity-teal') },
  get external_sensor_route() { return readMarker('camara-normal',   'entity-teal') },
  // Lee su propio token de marker, igual que device/bus. `entity-violet`
  // queda solo como fallback: es theme-invariant (#A87DD0) y solo coincide
  // con el marker en el tema neon — en desaturado/vibrante/tactical el
  // toggle del toolbar, la pestaña del sidebar, el slot de la cluster card
  // y el chip del drawer pintaban un violeta distinto al del marker que
  // etiquetan. La familia `external-device` de rules.js nació después de
  // este getter y nadie lo revisó.
  get external_device()       { return readMarker('external-device-normal', 'entity-violet') },
  get incident()              { return readMarker('incidente-activo','entity-red') },
  get sos_call()              { return readMarker('sos-esperando',   'alert-sos') },
  get reportant()             { return readMarker('neutro-apagado',  'status-idle') },
  get fire()                  { return readCssVar('entity-orange') },
  get sismo()                 { return readMarker('neutro-apagado',  'status-idle') },
  get presa()                 { return readMarker('neutro-apagado',  'status-idle') },
  get cpr()                   { return readMarker('bus-normal',      'entity-green') },
  get route_lpr()             { return readMarker('neutro-apagado',  'status-idle') },
  // Persona con medida cautelar seguida desde una alerta. Ámbar: distintivo
  // frente a unidades (azul), cámaras (teal) e incidentes (rojo).
  get medida_cautelar()       { return readMarker('sensor-standby',  'entity-orange') },
}

// GLASS_BG y GLASS_BORDER quedan hardcoded intencionalmente: son valores
// de presentacion que no cambian entre temas. Si algun tema futuro los
// necesita distintos, se convierten a getters en ese momento.
export const GLASS_BG = 'rgba(10, 14, 26, 0.3)'
export const GLASS_BORDER = 'rgba(255, 255, 255, 0.12)'

export const STATUS_COLORS = {
  get online()  { return readCssVar('status-online') },
  get up()      { return readCssVar('status-online') },
  get offline() { return readCssVar('status-offline') },
  get down()    { return readCssVar('status-offline') },
  get alert()   { return readCssVar('status-alert') },
  get idle()    { return readCssVar('status-idle') },
}

// Sigla cardinal EN ESPAÑOL para un rumbo en grados (0 = norte, sentido
// horario). Cada sigla cubre 45°, así que se toma la más cercana.
//
// Ojo con las tres últimas: antes decían SW / W / NW, que es inglés. Las otras
// cinco coinciden en ambos idiomas y por eso pasaba desapercibido — hasta que
// una unidad iba al oeste y el operador leía "W" en un sistema en español.
export function courseToCardinal(course) {
  if (course == null) return ''
  const dirs = ['N', 'NE', 'E', 'SE', 'S', 'SO', 'O', 'NO']
  return dirs[Math.round(course / 45) % 8]
}

export function timeAgo(date) {
  if (!date) return ''
  const diff = Date.now() - new Date(date).getTime()
  const s = Math.floor(diff / 1000)
  // "ahora" (corto) en lugar de "hace un momento" — el string largo rompía
  // el ancho del listado del sidebar cuando se mezclaba con "hace 1m",
  // "hace 2m", etc. Mantener todos los labels breves y homogéneos.
  if (s < 60) return 'ahora'
  const m = Math.floor(s / 60)
  if (m < 60) return `hace ${m}m`
  const h = Math.floor(m / 60)
  if (h < 24) return `hace ${h}h`
  return `hace ${Math.floor(h / 24)}d`
}
